export default "/images/framework/Bonus.e0bf0944.svg?e0bf0944";